import api from '@/apis/utils';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';
import { useEffect, useState } from 'react';
import usePrevious from '@/hooks/common/usePrevious';

const useImageQuery = (uri: string) => {
  const { token } = useRecoilValue(authState);
  const [value, setValue] = useState<{
    uri?: string;
    imageUri?: string;
    buffer?: ArrayBuffer;
  }>({
    uri: '',
    imageUri: '',
    buffer: undefined
  });
  const prevValue = usePrevious<string>(uri);

  useEffect(() => {
    if (uri !== prevValue) {
      (async () => {
        /** [이미지] token 체크하는 이미지 조회  */
        const buffer = await api.getImageBuffer(token, uri);
        const blob = new Blob([buffer], { type: 'text/xml' });
        const imageUri = URL.createObjectURL(blob);
        setValue({ uri, imageUri: imageUri ?? '', buffer: buffer });
      })();
    }
    return () => {};
  });

  useEffect(() => {
    return () => setValue({ uri: '', imageUri: '', buffer: undefined });
  }, []);

  return { value };
};

export default useImageQuery;
